import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { isNull, isUndefined } from 'lodash';

import { SvgIcon } from '@mui/material';
import { withStyles } from '@mui/styles';

import { ReactComponent as ArrowRightIcon } from '../images/icons/arrow-right.svg';
import { ReactComponent as CalendarIcon } from '../images/icons/calendar.svg';
import { ReactComponent as CloseIcon } from '../images/icons/close.svg';
import { ReactComponent as DigitsIcon } from '../images/icons/digits.svg';
import { ReactComponent as InfoIcon } from '../images/icons/info.svg';
import { ReactComponent as ListIcon } from '../images/icons/list.svg';
import { ReactComponent as LocationIcon } from '../images/icons/location.svg';
import { ReactComponent as PhoneIcon } from '../images/icons/phone.svg';
import { ReactComponent as SuccessIcon } from '../images/icons/success.svg';
import { ReactComponent as UserIcon } from '../images/icons/user.svg';

const styles = () => ({
  root: {},
});

function CustomIcon({ classes, className, icon, ...otherProps }) {
  if (isNull(icon) || isUndefined(icon)) {
    return null;
  }

  const selectIcon = iconName => {
    switch (iconName) {
      case 'arrow-right':
        return ArrowRightIcon;
      case 'calendar':
        return CalendarIcon;
      case 'close':
        return CloseIcon;
      case 'digits':
        return DigitsIcon;
      case 'info':
        return InfoIcon;
      case 'list':
        return ListIcon;
      case 'location':
        return LocationIcon;
      case 'phone':
        return PhoneIcon;
      case 'success':
        return SuccessIcon;
      case 'user':
        return UserIcon;
      default:
        return null;
    }
  };

  return <SvgIcon className={clsx(classes.root, className)} component={selectIcon(icon)} {...otherProps} />;
}
CustomIcon.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  icon: PropTypes.string,
};

CustomIcon.defaultProps = {
  classes: {},
  className: null,
  icon: null,
};

export default withStyles(styles)(CustomIcon);
